import { useSelector, useDispatch } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";

import { boldText } from "../../../../../utils/textUtils";

import UserInputBar from "../../widgets/UserInputBar";

const EngBlankPage = ({
  pageList,
  currentPage,
  currentIndex,
  userInput,
  selectedBlankIndex,
  setCurrentIndex,
  setUserInput,
  setSelectedBlankIndex,
  setPageList,
  setOverlayVisible,
}) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const changeSelectedBlank = (element) => {
    if (element.isSubmitted) return alert("이미 정답 제출한 빈칸입니다.");
    setSelectedBlankIndex(element.index);
    currentPage.data.question.forEach((question) => {
      if (question.type === "blank") {
        if (question.index === element.index) {
          // isSubmitted가 false이면 input을, true이면 firstAttemptAnswer를 보여줌
          if (currentPage.isSubmitted && question.firstAttemptAnswer) {
            setUserInput(question.firstAttemptAnswer);
          } else {
            setUserInput(question.input);
          }
        }
      }
    });
  };

  const handleSubmit = () => {
    if (currentPage.isSubmitted) return;

    const submitCount = currentPage.submitCount + 1;
    let isAllSubmitted = true;
    let data;

    if (submitCount < 10) {
      data = {
        ...currentPage.data,
        question: currentPage.data.question.map((element) => {
          if (element.type === "blank") {
            const isCorrect = element.input.replace(/[!.,:?]/g, "").toLowerCase() ===
              currentPage.data.answers[element.index]
                .replace(/[!.,:?]/g, "")
                .toLowerCase();
            
            const isFirstAttempt = element.firstAttemptCorrect === undefined;
            
            if (isCorrect) {
              return {
                ...element,
                isSubmitted: true,
                input: currentPage.data.answers[element.index],
                firstAttemptCorrect: isFirstAttempt ? true : element.firstAttemptCorrect,
                firstAttemptAnswer: isFirstAttempt ? element.input : element.firstAttemptAnswer,
              };
            } else {
              isAllSubmitted = false;
              return { 
                ...element, 
                input: "",
                firstAttemptCorrect: isFirstAttempt ? false : element.firstAttemptCorrect,
                firstAttemptAnswer: isFirstAttempt ? element.input : element.firstAttemptAnswer,
              };
            }
          }
          return element;
        }),
      };
    } else {
      data = {
        ...currentPage.data,
        question: currentPage.data.question.map((element) => {
          if (element.type === "blank") {
            return {
              ...element,
              isSubmitted: true,
              input: currentPage.data.answers[element.index],
              firstAttemptCorrect: element.firstAttemptCorrect,
              firstAttemptAnswer: element.firstAttemptAnswer,
            };
          }
          return element;
        }),
      };
    }

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: data,
          isSubmitted: isAllSubmitted,
          submitCount: submitCount,
        };
      }
      return prevPage;
    });

    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    dispatch(
      updateSection({ sectionId: section.id, data: { answer: newPageList } })
    );

    if (isAllSubmitted) {
      setSelectedBlankIndex(-1);
    } else {
      const notSubmittedElement = data.question.find(
        (element) => element.type === "blank" && element.isSubmitted === false
      );
      changeSelectedBlank(notSubmittedElement);
    }

    if (submitCount < 10) {
      setOverlayVisible(true);
      setTimeout(() => {
        setOverlayVisible(false);
        if (isAllSubmitted && currentIndex < pageList.length - 1) {
          setTimeout(() => {
            setCurrentIndex(currentIndex + 1);
            setUserInput("");
          }, 200);
        }
      }, 600);
    } else {
      alert(
        "제출 횟수를 초과하였습니다. 정답을 확인하고, 다음 문제로 넘어가세요."
      );
    }
  };

  const handleSetAnswer = () => {
    const nextElement = currentPage.data.question
      .filter(
        (element) => element.type === "blank" && element.isSubmitted === false
      )
      .find((element) => element.index > selectedBlankIndex);
    if (nextElement) {
      changeSelectedBlank(nextElement);
    }

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: {
            ...prevPage.data,
            question: prevPage.data.question.map((element) => {
              if (element.type === "blank") {
                if (element.index === selectedBlankIndex) {
                  return { ...element, input: userInput };
                }
              }
              return element;
            }),
          },
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          marginBottom: "20px",
        }}
      >
        {"빈칸을 채우세요."}
      </div>
      <div
        style={{
          fontSize: "28px",
        }}
      >
        {currentPage.type !== "" &&
          currentPage.data.question.map((element, index) => {
            if (element.type === "text") {
              return element.content;
            } else if (element.type === "blank") {
              const userAnswer = element.input;
              const blankLength = element.length;
              const isSelected = element.index === selectedBlankIndex;

              return (
                <span
                  key={"eng_blank_" + index}
                  onClick={() => changeSelectedBlank(element)}
                  style={{
                    display: "inline-block",
                    minWidth: 20,
                    marginRight: 4,
                    marginLeft: 4,
                    cursor: "pointer",
                    letterSpacing: userAnswer === "" ? "0" : null,
                    backgroundColor: isSelected
                      ? "#e0ffe0"
                      : userAnswer === ""
                      ? "transparent"
                      : "#EBEBEB",
                  }}
                >
                  {userAnswer || "_".repeat(blankLength)}
                </span>
              );
            }
            return null;
          })}
      </div>
      <div
        style={{
          fontSize: "20px",
          color: "#737373",
        }}
      >
        {boldText({ text: currentPage.data.kor || currentPage.data.eng })}
      </div>
      <div style={{ position: "relative", width: "60%", marginTop: "50px" }}>
        <UserInputBar
          handleSetAnswer={handleSetAnswer}
          handleChange={handleChange}
          userInput={
            currentPage.isSubmitted && selectedBlankIndex >= 0
              ? currentPage.data.question.find(q => q.type === "blank" && q.index === selectedBlankIndex)?.firstAttemptAnswer || userInput
              : userInput
          }
          disabled={currentPage.isSubmitted}
          type={"analysis"}
        />
      </div>
      <button
        style={{
          position: "absolute", // 부모(80% width) 안에서 절대 위치
          bottom: "90px", // 최하단으로부터 10px 떨어짐
          right: "60px", // 우측으로부터 10px 떨어짐
          padding: "10px 35px",
          backgroundColor: currentPage.isSubmitted ? "#EBEBEB" : "#2D2D2D",
          color: currentPage.isSubmitted === true ? "#737373" : "white",
          border: "none",
          fontSize: "18px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={() => handleSubmit()}
      >
        제출하기
      </button>
    </div>
  );
};

export default EngBlankPage;
